import _ from 'lodash';


const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

const routes = [
  {
    path: 'basic',
    name: 'basic',
    meta: {
      title: '基本信息',
    },
    component: _import('accounts/Basic.vue'),
  }, {
    path: 'members',
    name: 'members',
    meta: {
      title: '用户管理',
    },
    component: _import('accounts/Members.vue'),
  },{
    path: 'members/:id',
    name: 'editMember',
    meta: {
      title: '用户编辑',
    },
    component: _import('accounts/MemberEdit.vue'),
  },
  {
    path: 'departManage',
    name: 'departManage',
    meta: {
      title: '科室管理',
    },
    component: _import('accounts/departManage.vue'),
  },
  {
    path: 'linkAssignManage',
    name: 'linkAssignManage',
    meta: {
      title: '我的小组',
    },
    component: _import('accounts/LinkAssignManage.vue'),
  },{
    path: 'groupLinkAssignManage',
    name: 'groupLinkAssignManage',
    meta: {
      title: '用户/组别设置',
    },
    component: _import('accounts/GroupLinkAssignManage.vue'),
  }
];

export default _.map(routes, r => ({
  ...r,
  path: `accounts/${r.path}`,
  meta: _.defaults({
    auth: true,
  }, r.meta),
}));
